import {
  navbarHeight,
  navEventKey,
  Neighbors,
  useNavbarContext,
} from '@amzn/ring-ui-react-components';
import { useTranslation } from 'react-i18next';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerMenu,
  DrawerMenuItem,
} from 'src/shared/components/Drawer';
import { useLocalizedNavConfig } from 'src/shared/hooks';
import { getLoginUrl } from 'src/utils';
import { NavbarBase, NavMobileButton } from './NavbarBase';

const NavbarMobile = () => {
  const { t } = useTranslation(['components.navbar', 'common'], {
    useSuspense: false,
  });
  const { activeKey } = useNavbarContext();
  const { getTheApp, helpCenter, learnMore } = useLocalizedNavConfig();

  const isOpen = navEventKey === activeKey;

  return (
    <>
      <NavMobileButton href={getLoginUrl()} as="a" icon="account">
        {t('login', { ns: 'common' })}
      </NavMobileButton>
      <Drawer isOpen={isOpen} top={navbarHeight}>
        <DrawerBody>
          <DrawerMenu title={t('learn-more', { ns: 'common' })!}>
            <DrawerMenuItem as="a" href={getTheApp.url} icon={<Neighbors />}>
              {t(getTheApp.labelKey ?? 'get-the-app')}
            </DrawerMenuItem>
            <DrawerMenuItem as="a" href={learnMore.url} icon="account">
              {t(learnMore.labelKey ?? 'learn-more')}
            </DrawerMenuItem>
            <DrawerMenuItem
              as="a"
              href={helpCenter.url}
              icon="question-outline"
            >
              {t(helpCenter.labelKey ?? 'help-center')}
            </DrawerMenuItem>
          </DrawerMenu>
        </DrawerBody>
        <DrawerFooter>
          <DrawerMenu>
            <DrawerMenuItem href={getLoginUrl()} as="a" icon="sign-out">
              {t('login', { ns: 'common' })}
            </DrawerMenuItem>
          </DrawerMenu>
        </DrawerFooter>
      </Drawer>
    </>
  );
};

export const UnauthenticatedNavbarMobile = () => (
  <NavbarBase>
    <NavbarMobile />
  </NavbarBase>
);
